export default {
  surveyBuilder: {
    addNewSurvey: "Adicionar Nova Pesquisa",
    surveyTitle: "Título da Pesquisa",
    surveyName: "Nome da Pesquisa",
    surveyDescription: "Descrição da Pesquisa",
    describeSurvey: "Descreva a Pesquisa",
    enableScheduling: "Ativar Agendamento",
    selectedDate: "Data Selecionada",
    multiStepSurvey: "Pesquisa em Múltiplas Etapas",
    multiStepSurveyDetails:
      "Com base no número de perguntas em uma etapa, todas as perguntas da pesquisa serão agrupadas e exibidas em etapas.",
    multiStep: "Múltiplas Etapas",
    noQuestionEachStep: "Número de perguntas em cada etapa",
    surveyStatus: "Status da Pesquisa",
    surveyStatusDetails:
      "A pesquisa só pode ser ativada após a adição de perguntas. Ativar uma pesquisa permitirá que os agricultores comecem a enviar respostas.",
    selectUsers: "Selecionar Usuários",
    selectUsersDetails:
      "Se a opção 'Selecionar Usuário' estiver desabilitada, a pesquisa estará disponível para todos os usuários. Se você habilitar a seleção de usuários, poderá escolher vários usuários na próxima etapa.",
    linkWithFarms: "Vincular às Fazendas",
    linkWithFarmsDetails:
      "Se habilitado, a pesquisa será vinculada às fazendas individuais. Se um agricultor tiver várias fazendas, cada fazenda terá sua própria pesquisa.",
    enabled: "Ativado",
    disabled: "Desativado",
    cancel: "Cancelar",
    next: "Próximo",
    surveySettings: "Configurações da Pesquisa",

    selectSurveyUsers: "Selecionar Usuários da Pesquisa",
    selectToProceed: "Por favor, selecione usuário(s) para prosseguir",
    searchUsers: "Buscar Usuários",
    usersSelected: "Usuários Selecionados",
    conditional: "Condicional",
    autoConditional: "Condicional Automática",
    userName: "Nome de Usuário",
    email: "E-mail",
    membershipType: "Tipo de Associação",
    membershipValidity: "Validade da Associação",
    membershipRemainingDays: "Número de Dias Restantes",
    membershipRole: "Função de Membro",
    accountProgress: "Progresso da Conta",
    status: "Status",
    active: "Ativo",
    deactivated: "Desativado",
    continue: "Continuar",
    questions: "Perguntas",
    responses: "Respostas",
    deleteSurvey: "Excluir Pesquisa",
    editSurvey: "Editar Pesquisa",
    type: "Tipo",
    compulsory: "Obrigatório",
    createSurvey: "Criar Pesquisa",
    surveyBuilder: "Construtor de Pesquisas",
    surveyList: "Lista de Pesquisas",
    farm: "Fazenda",
    responseDate: "Data da Resposta",
    viewSurvey: "Visualizar Pesquisa",
    question: "Pergunta",
    settings: "Configurações",
    addQuestion: "Adicionar Pergunta",
    surveysSubmitted: "Pesquisas Enviadas",
    surveyDetail: "Detalhes da Pesquisa",
    conditionStatus: "Status da Condição",
    conditionStatusDesc:
      "Usuários que correspondem às condições se tornarão automaticamente elegíveis para a pesquisa.",

    endSurvey: "Encerrar Pesquisa",
    publishSurvey: "Publicar Pesquisa",
    copy: "Copiar",
    view: "Visualizar",
    startDate: "Data de Início",
    endDate: "Data de Término",
    chooseDate: "Escolher data",
    select: "Selecionar",
    addSurveyQuestion: "Adicionar Pergunta da Pesquisa",
    editSurveyQuestion: "Editar Pergunta da Pesquisa",
    questionScore: "Pontuação da Pergunta",
    mandatory: "Obrigatória",
    yes: "Sim",
    no: "Não",
    options: "Opções",
    typeHere: "Digite aqui",
    add: "Adicionar",
    optionsHint:
      "Por favor, pressione Enter para adicionar uma resposta ou clique em Adicionar",
    surveyProgress: "Pesquisa em progresso",
    allResponses: "Resumo de Todas as Respostas",
    responseQuestion: "Respostas por Pergunta",
    dateSubmitted: "Data de Envio",
    answer: "Respostas",
    totalScore: "Pontuação Total",
    score: "Pontuação",
    singleSelection: "Seleção Única",
    multipleSelection: "Seleção Múltipla",
    if: "Se",
    then: "então",
    noResponse: "Sem resposta",
    noSurveyFound: "Nenhuma Pesquisa Encontrada",
    createNewSurvey:
      'Por favor, crie uma pesquisa usando o botão "Criar Pesquisa" acima',
    cannotPublish: "Não é possível publicar uma pesquisa desabilitada!",
    deleteSurveyWarn:
      "Você tem certeza de que deseja excluir a pesquisa? Se você a excluir, todas as perguntas e respostas da pesquisa serão excluídas permanentemente.",
    noQuestionFound: "Nenhuma Pergunta Encontrada",
    createQuestion:
      'Por favor, adicione uma pergunta primeiro usando o botão "ADICIONAR PERGUNTAS" acima',
    deleteQuestion: "Tem certeza de que deseja excluir a pergunta?",
    applyChanges: "Como você gostaria de aplicar essas mudanças?",
    editFutureSurveys: "EDITAR APENAS PESQUISAS FUTURAS",
    editLiveSurveyOnly: "EDITAR APENAS PESQUISA ATIVA",
    surveyIsLive:
      "Por favor, note que a pesquisa está atualmente ativa, e editar uma pergunta neste momento pode afetar envios anteriores. Para evitar problemas, você pode considerar criar uma cópia da pesquisa para fazer alterações nas perguntas.",
    clickToCopy: "Clique Aqui Para Criar uma Cópia da Pesquisa",
    applyChangesNow: "APLICAR MUDANÇAS AGORA",
    copySurvey: "Copiar Pesquisa",
    changeCopySurveyName:
      "Você pode alterar o nome da versão copiada da pesquisa.",

      textField: "Campo de Texto",
      textArea: "Área de Texto",
      textFieldNumeric: "Campo de Texto Numérico",
      radioButton:  "Botão de Rádio",
      checkBoxes: "Caixas de Seleção",
      fileAttachment: "Anexo de Arquivo",
      digitalSignature: "Assinatura Digital",
      gpsLocation: "Localização GPS",
      dynamicFarmer: "Agricultor Dinâmico",
      dynamicGeofence: "Geofence Dinâmico",
      dynamicCrop: "Cultura Dinâmica",
      dynamicEquipment: "Equipamentos Dinâmicos",
      downloadSurvey: "Baixar Pesquisa",
      downloadQuestion:  "Baixar Apenas Perguntas",
      downloadResponse:  "Baixar Todas as Respostas",
      chooseFileFormat:  "Escolha o Formato do Arquivo",
      surveyTitleLength:  "O título da pesquisa deve ter menos de 100 caracteres",
      selectAllFiltered:  "Selecionar tudo filtrado",
      surveyDownloads:  "Downloads de Pesquisa",

  },
}